import { createSlice } from '@reduxjs/toolkit';

import { PageSizing } from 'Shared/Core/Common/Options/PageSizing';

import { deleteReminder, getSendingRemindersByCurrentUserPagedFilter } from './action';
import IRemindersListState from './model';

const initialState: IRemindersListState = {
  reminders: {
    loading: false,
    data: {
      pageNumber: 0,
      pageSize: PageSizing[1].value as number,
      totalCount: 0,
      queryResult: null,
    },
    queryParams: {
      pageNumber: 1,
      pageSize: 10,
      needTotalCount: true,
      sortAscending: false,
      sortBy: null,
    },
    pagination: {
      currentPage: 1,
      tableColumn: 0,
      totalPage: 0,
      customPageSize: PageSizing[1].value as number,
      firstItemNumber: 0,
      lastItemNumber: 0,
    },
  },
  deleteReminderState: {
    loading: false,
    isSuccess: false,
  },
};

export const remindersListSlice = createSlice({
  name: 'reminder/RemindersList',
  initialState,
  reducers: {
    setTotalPage: (state, action) => {
      state.reminders.pagination.totalPage = action.payload;
    },
    setNextPage: (state) => {
      if (state.reminders.pagination.currentPage < state.reminders.pagination.totalPage) {
        state.reminders.pagination.currentPage = state.reminders.pagination.currentPage + 1;
        state.reminders.queryParams.pageNumber = state.reminders.pagination.currentPage;
      }
    },
    setPervPage: (state) => {
      if (state.reminders.pagination.currentPage > 1) {
        state.reminders.pagination.currentPage = state.reminders.pagination.currentPage - 1;
        state.reminders.queryParams.pageNumber = state.reminders.pagination.currentPage;
      }
    },
    setFirstPage: (state) => {
      state.reminders.pagination.currentPage = 1;
      state.reminders.queryParams.pageNumber = state.reminders.pagination.currentPage;
    },
    setEndPage: (state) => {
      state.reminders.pagination.currentPage = state.reminders.pagination.totalPage;
      state.reminders.queryParams.pageNumber = state.reminders.pagination.currentPage;
    },
    setCurrentPage: (state, action) => {
      state.reminders.pagination.currentPage = action.payload;
      state.reminders.queryParams.pageNumber = state.reminders.pagination.currentPage;
    },
    setCustomPageSize: (state, action) => {
      state.reminders.pagination.customPageSize = action.payload;
      state.reminders.queryParams.pageSize = state.reminders.pagination.customPageSize;
    },
    setFirstItemNumber: (state, action) => {
      state.reminders.pagination.firstItemNumber = action.payload;
    },
    setLastItemNumber: (state, action) => {
      state.reminders.pagination.lastItemNumber = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSendingRemindersByCurrentUserPagedFilter.pending, (state) => {
        state.reminders.loading = true;
        state.reminders.data = initialState.reminders.data;
      })
      .addCase(getSendingRemindersByCurrentUserPagedFilter.fulfilled, (state, action) => {
        state.reminders.loading = false;
        if (action.payload !== undefined) {
          state.reminders.data = action.payload;
        }
        return state;
      })
      .addCase(getSendingRemindersByCurrentUserPagedFilter.rejected, (state) => {
        state.reminders.loading = false;
      });

    builder
      .addCase(deleteReminder.pending, (state) => {
        state.deleteReminderState.loading = true;
      })
      .addCase(deleteReminder.fulfilled, (state, action) => {
        state.deleteReminderState.loading = false;
        if (action.payload && action.payload.status === 200) {
          state.deleteReminderState.isSuccess = true;
        }
      })
      .addCase(deleteReminder.rejected, (state) => {
        state.deleteReminderState.loading = false;
      });
  },
});

export const {
  setTotalPage,
  setNextPage,
  setPervPage,
  setFirstPage,
  setEndPage,
  setCurrentPage,
  setCustomPageSize,
  setFirstItemNumber,
  setLastItemNumber,
} = remindersListSlice.actions;

export default remindersListSlice.reducer;
